import * as z from "zod/mini";

const LOCALSTORAGE_KEY = "qrcodeReaderEnabledModes";

const enabledModesSchema = z.object({
  isChecked: z.boolean(),
  isRedeemed: z.boolean(),
});

export type EnabledModes = z.infer<typeof enabledModesSchema>;

const DEFAULT_ENABLED_MODES: EnabledModes = {
  isChecked: true,
  isRedeemed: true,
};

export const getEnabledModes = (): EnabledModes => {
  try {
    const stored = localStorage.getItem(LOCALSTORAGE_KEY);
    if (!stored) return DEFAULT_ENABLED_MODES;
    const result = enabledModesSchema.safeParse(JSON.parse(stored));
    if (!result.success) return DEFAULT_ENABLED_MODES;
    return result.data;
  } catch {
    return DEFAULT_ENABLED_MODES;
  }
};

export const setEnabledModes = (modes: EnabledModes) => {
  localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(modes));
};
